// import React from "react";

// const socialMediaPlatforms = [
//   {
//     name: "Facebook",
//     description: "Connect with friends and the world around you.",
//     link: "https://www.facebook.com/share/15nNHb6u7n/?mibextid=wwXIfr",
//     logo: "./assets/img/socailmedia_fb.png",
//   },
//   {
//     name: "Instagram",
//     description: "Share your moments through photos and stories.",
//     link: "https://www.instagram.com/tita_technologies_global/profilecard/?igsh=MThwcTc4dGw1ZXp3MA==",
//     logo: "./assets/img/socialmedia_insta.png",
//   },
//   {
//     name: "Twitter",
//     description: "See what's happening in the world right now.",
//     link: "https://x.com/tita_global?s=11",
//     logo: "./assets/img/socialmedia_X.png",
//   },
//   {
//     name: "LinkedIn",
//     description: "Build your professional network.",
//     link: "https://www.linkedin.com/company/tita-technologies/",
//     logo: "./assets/img/socialmedia_linkedin.png",
//   },
// ];

// const SocialMediaPage = () => {
//   return (
//     <div className="min-h-screen bg-gray-100 p-6">
//     <h1 className="text-3xl font-bold text-center mb-8 text-gray-800">
//       Social Media Platforms
//     </h1>
//     <div className="grid gap-6 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
//       {socialMediaPlatforms.map((platform, index) => (
//         <div
//           key={index}
//           className="bg-white rounded-lg shadow-lg p-5 hover:shadow-xl transition-shadow duration-300"
//         >
//           <div className="flex items-center space-x-4">
//             <img
//               src={platform.logo}
//               alt={`${platform.name} logo`}
//              style={{width: "100px", height: "100px"}}
//             />
//             <h2 className="text-xl font-semibold text-gray-700">
//               {platform.name}
//             </h2>
//           </div>
//           <p className="text-gray-600 mt-3">{platform.description}</p>
//           <button style={{background: "#ff001e", color: "#fff", padding: "10px 20px", cursor: "pointer", border: "none", borderRadius: "5px"}}>
//           <a
//             href={platform.link}
//             target="_blank"
//             rel="noopener noreferrer"
//             style={{color: "#fff"}}
//           >
//             Visit {platform.name}
//           </a>
//           </button>
//         </div>
//       ))}
//     </div>
//   </div>
//   );
// };

// export default SocialMediaPage;

import React from "react";

const communities = [
  {
    name: "Facebook Community",
    description: "Connect with our Facebook community for updates and discussions.",
    link: "https://www.facebook.com/share/g/15TsxRRC1h/",
    logo: "./assets/img/socailmedia_fb.png",
  },
  {
    name: "WhatsApp Community",
    description: "Join our WhatsApp group for real-time chats and support.",
    link: "https://chat.whatsapp.com/C0RL1FKLeUk0MMQpHyIE1x",
    logo: "./assets/img/socailmedia_whatsapp.png",
  },
];

const SocialMediaPage = () => {
  return (
    <div
      style={{
        minHeight: "100vh",
        backgroundColor: "#f9fafb",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: "24px",
      }}
    >
      <h1
        style={{
          fontSize: "2.5rem",
          fontWeight: "bold",
          color: "#1f2937",
          marginBottom: "32px",
        }}
      >
        Join Our Communities
      </h1>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(2, 1fr)",
          gap: "40px",
        }}
      >
        {communities.map((community, index) => (
          <div
            key={index}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              backgroundColor: "#ffffff",
              padding: "24px",
              borderRadius: "8px",
              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
              transition: "box-shadow 0.3s",
              cursor: "pointer",
            }}
            onMouseEnter={(e) =>
              (e.currentTarget.style.boxShadow = "0 6px 10px rgba(0, 0, 0, 0.15)")
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.boxShadow = "0 4px 6px rgba(0, 0, 0, 0.1)")
            }
          >
            <img
              src={community.logo}
              alt={`${community.name} logo`}
              style={{
                width: "120px",
                height: "120px",
                marginBottom: "10px",
              }}
            />
            <h2
              style={{
                fontSize: "1.25rem",
                fontWeight: "600",
                color: "#4b5563",
                marginBottom: "8px",
                textAlign: "center",
              }}
            >
              {community.name}
            </h2>
            <p
              style={{
                color: "#6b7280",
                fontSize: "0.875rem",
                marginBottom: "16px",
                textAlign: "center",
              }}
            >
              {community.description}
            </p>
            <a
              href={community.link}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                backgroundColor: "#dc2626",
                color: "#ffffff",
                padding: "10px 24px",
                borderRadius: "9999px",
                textDecoration: "none",
                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                transition: "background-color 0.3s",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#b91c1c")}
              onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#dc2626")}
            >
              Join Now
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SocialMediaPage;

